import React, { useContext, useEffect, useState } from 'react'
import { Card, CardBody, IconButton, Checkbox, Spinner } from "@material-tailwind/react";
import { BiEdit } from 'react-icons/bi';
import { get_surprise_me } from '../../Controller/actions';
import { NewContext } from '../../Context/NewContext';
import { RiDeleteBinLine } from 'react-icons/ri';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { Pagination } from '../../Components/Pagination/Pagination';
import { SearchAndAddBtn } from '../../Components/SearchAndAddBtn/SearchAndAddBtn';
import Switch from '../../Components/Switch/Switch';
import { THead } from '../../Components/Table/THead';
import SupersieMeModel from '../../Components/Modals/SurpriseMeModel';


const SurpriseMe = ({ title }) => {
    const { permissions, tokenType, infoData, setDeleteUpdateTag, deleteUpdateItem, setDeleteUpdateItem, setAddEditDeleteTag, setFormData, confirmationModalShow, setConfirmationModalShow, handleSwitchUpdate, isLoading, deleteUpdateTag, checkedValues, handleCheckboxChange, currentPage, totalPage, perPage, search, setDeleteUpdateYes, setIsLoading, setCurrentPage, setPerPage, setTotalPage, currentPageData, setCurrentPageData, filterDropdown, handleOpen, isAscending, sortData } = useContext(NewContext);
    const simpleFields = [
        { name: "Prompt", },
    ];
    const [pagePermissions, setPagePermissions] = useState({
        CU: true,
        R: true,
        D: true
    });
    const dropdownFields = [{ name: "Active", }];
    const totalFields = simpleFields.length + dropdownFields.length + 2;

    const getSurpriseMeData = async (_currentPage = 1, sortName = sortData, sortType = isAscending) => {
        setIsLoading(true);
        try {
            const getPrompts = await get_surprise_me(_currentPage, perPage, search, filterDropdown, sortName, sortType);
            if (getPrompts) {
                const { status, data, currentPage, perPage, totalPage } = getPrompts;
                if (status) {
                    setCurrentPageData(data);
                    setCurrentPage(currentPage);
                    setPerPage(perPage);
                    setTotalPage(totalPage || 1);
                } else {
                    setCurrentPageData([]);
                }
            }
        } catch (error) {
            console.error(error);
        }
        setIsLoading(false);
    }

    useEffect(() => {
        getSurpriseMeData(currentPage, sortData, isAscending);
        setDeleteUpdateTag("");
    }, [deleteUpdateTag, search, currentPage, perPage, filterDropdown, sortData, isAscending]);

    useEffect(() => {
        if (tokenType === 'ldap') {
            const update = permissions?.subPermissions?.find((route) => route.name === 'Surprise Me');
            setPagePermissions({ ...pagePermissions, CU: update?.CU, R: update?.R, D: update?.D })
        }
    }, [tokenType, permissions])

    useEffect(() => {
        document.title = title;
    }, [title])

    return (
        <>
            <SearchAndAddBtn title={`Surprise Me`} addBtn={pagePermissions?.CU} deleteUpdateTag='all-delete-surpriseMe' resetFilterBtn={false} />
            <Card className="overflow-hidden w-full rounded-md shadow-none">
                <CardBody className="overflow-x-auto w-100 py-2.5 px-[5px] card-body-scrollbar">
                    <table className="w-full min-w-max table-auto text-left">
                        <THead simpleFields={simpleFields} dropdownFields={dropdownFields} />
                        <tbody>
                            {isLoading ? (
                                <tr>
                                    <td colSpan={totalFields} className='py-12'>
                                        <div className="flex justify-center items-center">
                                            <Spinner />
                                        </div>
                                    </td>
                                </tr>
                            ) : currentPageData?.length === 0 ? (
                                <tr>
                                    <td colSpan={totalFields} className='py-12 bg-gray-200'>
                                        <div className="flex justify-center items-center">
                                            No Data Found
                                        </div>
                                    </td>
                                </tr>
                            ) : (
                                currentPageData?.map((_ele, i) => {
                                    const isLast = i === currentPageData?.length - 1;
                                    const classes = `text-[#1E1627] ${isLast ? "p-4" : "p-[14.5px]"}`;
                                    return (
                                        <tr className='border-b border-blue-gray-50'>
                                            <td className={classes}>
                                                <Checkbox
                                                    className='w-[18px] h-[18px] border-[1.5px] rounded-[3.6px] border-[#1E3354] checked:bg-[#0047FF] checked:border-transparent'
                                                    id={`slider-${_ele._id}`}
                                                    value={`${_ele._id}`}
                                                    disabled={!pagePermissions?.CU}
                                                    checked={checkedValues.includes(`${_ele._id}`)}
                                                    onChange={() => handleCheckboxChange(`${_ele._id}`)}
                                                />
                                            </td>
                                            <td className={`${classes} max-w-[300px]`}>
                                                <div className="flex items-center truncate">
                                                    <span className={`font-normal text-[17px] !w-25 overflow-hidden whitespace-nowrap ${!_ele.prompt && `text-gray-500`}`}>
                                                        {_ele.prompt || `None`}
                                                    </span>
                                                </div>
                                            </td>
                                            {["isActive"].map((_is_ele, i) => (
                                                <td className={classes} key={i}>
                                                    <div className="ml-1">
                                                        <Switch disabled={!pagePermissions?.CU} id={_ele._id} name={_is_ele} onChange={(e) => { setDeleteUpdateYes("update-surpriseMe"); handleSwitchUpdate(e); }} checked={_ele[_is_ele]} />
                                                    </div>
                                                </td>
                                            ))}
                                            <td className={classes}>
                                                <div className="flex items-center gap-2">
                                                    <IconButton className='bg-[#EAEDF3] text-[#0047FF] text-[21px] shadow-none hover:shadow-none' disabled={!pagePermissions?.CU} onClick={() => { setDeleteUpdateYes("update-surpriseMe"); setAddEditDeleteTag(`update`); setFormData(_ele); handleOpen() }}>
                                                        <BiEdit />
                                                    </IconButton>
                                                    <IconButton className='bg-[#EAEDF3] text-[#F62929] text-[21px] shadow-none hover:shadow-none' disabled={!pagePermissions?.D} onClick={() => { setDeleteUpdateYes("delete-surpriseMe"); setDeleteUpdateItem({ id: _ele._id }); setConfirmationModalShow(!confirmationModalShow) }}>
                                                        <RiDeleteBinLine />
                                                    </IconButton>
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })
                            )}
                        </tbody>
                    </table>
                </CardBody>
            </Card>
            {totalPage > 1 && <Pagination currentPage={currentPage} totalPage={totalPage} getData={getSurpriseMeData} />}
            <SupersieMeModel />
        </>
    )
}
SurpriseMe.defaultProps = {
    title: "Ai Picture Generator | Surprise Me"
};
export default SurpriseMe